import { render, staticRenderFns } from "./AddJobPlace.vue?vue&type=template&id=06e21eb8"
import script from "./AddJobPlace.vue?vue&type=script&lang=js"
export * from "./AddJobPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports